import { z } from 'zod'
import { UserFileReadSchema } from '@/uppy-file-upload/schemas'

/**
 * FileListResponse - list of files in a folder
 * Used by: GET /api/v1/user-files/folders/{folder_id}/files
 */
export const FileListResponseSchema = z.object({
  files: z.array(UserFileReadSchema),
  folder_id: z.string().uuid(),
  next_cursor: z.string().nullable(),
})

export type FileListResponse = z.infer<typeof FileListResponseSchema>
